/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import { i, n as a, r as o, t as s } from "./uberblick-DAxGUR-q.js";
import { LitElement as c, html as l } from "lit";
import { customElement as u, property as d } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/product-logo/product-logo.css.js
var f = r(":host{line-height:0;display:inline-block}:host>img{object-fit:contain;width:100%;max-width:100%;height:100%;max-height:100%;filter:var(--darkmode-filter-reversal);display:block}"), p = {
	intratool: {
		url: o,
		label: "Intratool"
	},
	uberblick: {
		url: s,
		label: "Überblick"
	},
	horeca: {
		url: i,
		label: "Horeca Hero"
	},
	onboard: {
		url: a,
		label: "Onboard"
	}
}, m = class extends e(c) {
	constructor(...e) {
		super(...e), this.product = "intratool", this.styles = f;
	}
	render() {
		let { url: e, label: t } = p[this.product];
		return l`<img src=${e} alt=${t} />`;
	}
};
n([d({ reflect: !0 }), t("design:type", Object)], m.prototype, "product", void 0), m = n([u("ptc-ui-product-logo")], m);
//#endregion
export { m as t };

//# sourceMappingURL=product-logo-8eq8_r9x.js.map